var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("editar-recurso"),
      _vm._v(" "),
      _c("crear-recurso"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("v-toolbar-title", [
                _vm._v(
                  _vm._s(
                    _vm.sistemSelected === 0
                      ? "Selecciona un sistema"
                      : _vm.rolSelected === 0
                      ? "Seleccione un rol"
                      : "Lista de recursos"
                  )
                )
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.sistemas,
                  "item-text": "descripcion",
                  "item-value": function(val) {
                    return parseInt(val.id)
                  },
                  label: "Sistemas",
                  loading: _vm.sistemas.length === 0
                },
                on: { change: _vm.obtenerRoles }
              }),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.roles,
                  "item-text": "descripcion",
                  "item-value": function(val) {
                    return parseInt(val.id)
                  },
                  label: "Roles",
                  loading: _vm.roles.length === 0 && _vm.sistemSelected !== 0,
                  disabled: _vm.sistemSelected === 0
                },
                on: { change: _vm.obtenerRecursos }
              }),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        slot: "activator",
                        color: "primary",
                        dark: "",
                        disabled:
                          _vm.sistemSelected === 0 || _vm.rolSelected === 0
                      },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.crearRecurso()
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.add")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Agregar recurso")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  "no-data-text": "Seleccione un sistema para ver los roles",
                  "item-key": "roles-by-sistem",
                  headers: _vm.headers,
                  items: _vm.recursos,
                  "rows-per-page-text": "Filas por página",
                  "rows-per-page-items": [5, 10, 25],
                  rowsPerPageText: _vm.$t("common.rowsPage")
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.descripcion))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            _vm._s(
                              items.item.padre
                                ? items.item.padre.descripcion
                                : "NO TIENE"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nivel))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.ruta))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-center",
                            attrs: { title: items.item.icono }
                          },
                          [_c("v-icon", [_vm._v(_vm._s(items.item.icono))])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { attrs: { title: "Activar/Desactivar recurso" } },
                          [
                            _c("v-switch", {
                              attrs: {
                                value: "",
                                "input-value":
                                  items.item.id_estado === "1" ? true : false
                              },
                              on: {
                                change: function($event) {
                                  return _vm.cambiarEstado(items.item)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      color: "primary",
                                      dark: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editarRecurso(items.item)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("edit")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Editar registro")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      color: "error"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.eliminarRecurso(items.item)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Eliminar registro")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e280944", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e280944","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/rol-recurso/components/Recurso.vue
// module id = null
// module chunks = 